<template>
    <div class="section">
        <cars-table v-if="isAdmin || isSalesStaff || isSupplier"></cars-table>
        <cars-user-table v-else></cars-user-table>
    </div>
</template>

<script>
    import CarsTable from './CarsTable'
    import CarsUserTable from "./CarsUserTable";
    export default {
        components: {
            CarsTable,
            CarsUserTable
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            },
            isSupplier() {
                if (this.$store.getters.getUserRole === 'Supplier') {
                    return true
                }else{
                    return false
                }

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/CarsList.vue